import{ComponentInterface}from'../component-interface';class GlobalStore extends ComponentInterface{getName(){return'globalStore'}getType(){return'globalStore'}}export default GlobalStore;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-core/src/constructor/global-store.js
// module id = null
// module chunks = 